import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultItemPickerAssets, itemPickerAssetsValidator } from '../../../subcomponents/item-picker/types/assets';
import { defaultItemPickerCdnOptions, itemPickerCdnOptionsValidator } from '../../../subcomponents/item-picker/types/cdn-options';
import { defaultItemPickerConfig, itemPickerConfigValidator } from '../../../subcomponents/item-picker/types/config/config';
import { defaultItemPickerDisplayText, itemPickerDisplayTextValidator } from '../../../subcomponents/item-picker/types/display-text';
import { itemPickerEventsValidator } from '../../../subcomponents/item-picker/types/events';
export const siteItemPickerPropsValidator = Validator.object({
    siteId: Validator.optional(nonEmptyStringValidator),
    displayText: itemPickerDisplayTextValidator,
    events: itemPickerEventsValidator,
    config: itemPickerConfigValidator,
    assets: itemPickerAssetsValidator,
    cdnOptions: itemPickerCdnOptionsValidator
});
/**
 * Default props for the Site Item Picker component.
 */
export const defaultSiteItemPickerProps = {
    siteId: undefined,
    displayText: defaultItemPickerDisplayText,
    events: {},
    config: defaultItemPickerConfig,
    assets: defaultItemPickerAssets,
    cdnOptions: defaultItemPickerCdnOptions
};
